import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LoginPage from "./pages/LoginPage";
import LandingPage from "./pages/LandingPage";
import BugListPage from "./pages/BugListPage";
import BugDetailPage from "./pages/BugDetailPage";

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Public Route - redirects to bugs if already logged in
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  
  if (token) {
    return <Navigate to="/bugs" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className="App min-h-screen bg-[#F9FAFB]">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          } />
          <Route path="/" element={
            <PublicRoute>
              <LandingPage />
            </PublicRoute>
          } />
          <Route path="/bugs" element={
            <ProtectedRoute>
              <BugListPage />
            </ProtectedRoute>
          } />
          <Route path="/bugs/:recordId" element={
            <ProtectedRoute>
              <BugDetailPage />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
